import React from 'react'

const SiteLogo = () => {
    return (
        <div className="logo">
           <img src="img/film-ico.svg" alt="logo film"/>
           <h1>Cinema-Deluxe</h1>
        </div>
    )
}

export default SiteLogo
